module.exports = __webpack_public_path__ + "static/media/Lungs.ef3524f8.png";